// openapi-fetch surfaces a non-ok response's parsed body as the `error` field of
// a GET/POST result. The API shapes errors the FastAPI way: `{ detail: string }`
// for handled errors (see apps/api/errors.py) or `{ detail: [{ msg, ... }] }` for
// request-validation failures. This helper lifts the user-facing message out of
// that shape and falls back to a caller-supplied default when the body is missing,
// malformed, or a non-error string -- so hooks surface the server's reason instead
// of a fixed string, without ever leaking a raw exception or stack to the UI.
export function toApiError(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null || !("detail" in error)) {
    return fallback;
  }
  const detail = (error as { detail?: unknown }).detail;

  if (typeof detail === "string") {
    const trimmed = detail.trim();
    return trimmed.length > 0 ? trimmed : fallback;
  }

  if (Array.isArray(detail)) {
    for (const item of detail) {
      if (
        typeof item === "object" &&
        item !== null &&
        typeof (item as { msg?: unknown }).msg === "string"
      ) {
        const msg = (item as { msg: string }).msg.trim();
        if (msg.length > 0) {
          return msg;
        }
      }
    }
  }

  return fallback;
}
